import React from 'react';
import ListContact from './listContact';

// La liste porte sa propre fiche : cet enrobage n'ajoutait qu'une grille.
function Contacts() {
  return <ListContact />;
}

export default Contacts;
